<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '400px' }"
    header="Pesquisar solicitação"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="field">
      <label for="protocolor">Nº Protocolo:</label>
      <InputText
        placeholder="Digite o número do protocolo."
        type="number"
        id="n_prot_solicitacao"
        v-model="codigoSolicitacao"
      />
    </div>
    <template #footer>
      <Button
        label="Buscar"
        @click="buscarAtendimento"
        :disabled="!codigoSolicitacao"
        icon="pi pi-check"
        class="p-button-raised"
      />
    </template>
  </Dialog>
  <dialog-details :objSelected="solicitacao" />
</template>

<script>
import DialogDetails from "../../../components/solicitation/dialog-details.vue";
//Models
import Solicitation from "../../../models/internal/solicitation";
//Services
import SolicitationService from "../../../service/solicitation/solicitation_service";
export default {
  components: {
    DialogDetails,
  },
  data() {
    return {
      codigoSolicitacao: null,
      solicitacaoService: null,
      solicitacao: null,
    };
  },
  created() {
    this.codigoSolicitacao = null;
    this.solicitacaoService = new SolicitationService();
    this.solicitacao = new Solicitation();
  },
  computed: {
    visibleDialog: {
      get() {
        return this.$store.getters.getDialogExternalCard;
      },
      set(value) {
        this.$store.commit("setDialogExternalCard", value);
      },
    },
    dialogDetails: {
      get() {
        return this.$store.state.views.solicitation.consult.dialogDetails;
      },
      set(value) {
        this.$store.state.views.solicitation.consult.dialogDetails = value;
      },
    },
  },
  methods: {
    buscarAtendimento() {
      this.solicitacaoService
        .findById(this.codigoSolicitacao)
        .then((data) => {
          this.showDetails(this.solicitacao);
          this.solicitacao = data;
          this.codigoSolicitacao = null;
          this.dialogDetails = true;
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            detail: `Desculpe. Não foi encontrado nenhum registro/solicitação para o
              protocolo ${this.codigoSolicitacao}`,
          });
        });
    },
    showDetails(solicitacao) {
      this.solicitacao = solicitacao;
      this.$store.state.views.solicitation.consult.dialogDetails = true;
    },
    hideDialog() {
      this.solicitacao = new Solicitation();
      this.codigoSolicitacao = null;
    },
  },
};
</script>
<style lang="scss" scoped></style>
